<template>
  <div class="home-content" @click="handleClick">
    <Head ref="head" :backFn="back"></Head>
    <template v-if="isMaxScreen">
      <div class="pc_content">
        <PCBreadNav></PCBreadNav>
        <div class="card">
          <h5>{{ blogDetail.title }}</h5>
          <p>
            {{ formattedDate(blogDetail.publishTime) }}
            <span>{{ blogDetail.views }} {{$t('blog.blogDetail.64wgr9y5r7s0')}}</span>
          </p>
          <div class="content" v-html="safeContent"></div>
          <!-- <div class="article-tip">
            Article for the author's independent views do not represent the position of this
            website, without permission may not be reproduced.
          </div> -->
        </div>
      </div>
      <bottom ref="bottom" :showArrow="false"></bottom>
    </template>
    <template v-else>
      <div class="content">
        <div class="card">
          <h5>{{ blogDetail.title }}</h5>
          <p>
            <span>{{ blogDetail.views }} {{$t('blog.blogDetail.64wgr9y5r7s0')}}</span> {{ formattedDate(blogDetail.publishTime) }}
          </p>
          <div class="content" v-html="safeContent"></div>
          <!-- <div class="article-tip">
            Article for the author's independent views do not represent the position of this
            website, without permission may not be reproduced.
          </div> -->
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PCBreadNav from '@/components/PCBreadNav/index2.vue';
import { isES } from '@/locales';
import { getBlogDetail,getBlogList } from '@/services/api/home';
import { getChannelId, getNationCode } from '@/utils/channel';

import Bottom from '../../components/bottom';
import Head from '../../components/head';
import { sanitizeHtml } from '@/utils/sanitizeHtml';
export default {
  name: 'Home',
  components: {
    Head,
    Bottom,
    PCBreadNav
  },
  data() {
    return {
      isES,
      blogDetail: {}
    };
  },
  computed: {
    safeContent() {
      return sanitizeHtml(this.blogDetail && this.blogDetail.content);
    },
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getBlogDetail();
  },
  methods: {
    formattedDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    /**
     * 获取博客详情
     */
    getBlogDetail() {
      const channelId = getChannelId();
      const nation = getNationCode();
      const data = {
        channelId: channelId,
        nation: nation,
        id: this.$route.query.id
      };

      getBlogDetail(data).then(res => {
        const { code, data } = res;
        if (code === '0000') {
          this.blogDetail = { ...data, content: sanitizeHtml(data && data.content) };
        }
      });
    },
    handleClick() {
      this.$refs.head.hidLangeList();
    },
    back() {
      this.$router.push({ name: 'Home' });
    },
    // 跳转页面
    toPage(name) {
      if (!this.checked && name === 'Product') {
        return;
      }
      this.$router.push({ name });
    }
  }
};
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  .pc_content {
    width: 1240px;
    min-height: 100%;
    background: #fff;
    font-family: 'PingFang SC';
    margin-top: 100px;
    background: #f7f7f7;
    margin: 124px auto 0;
  }
  .card {
    // min-height: 800px;
    margin: 0px auto 110px;
    background: #fff;
    border-radius: 12px;
    padding: 40px;
    // position: relative;
    h5 {
      color: var(---Text-1, #252629);
      font-family: 'PingFang SC';
      font-size: 40px;
      font-style: normal;
      font-weight: 500;
      line-height: 135%; /* 54px */
      margin: 0 0 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    p {
      color: var(--text-3, #8f949d);
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 24px */
      margin-bottom: 25px;
      span {
        display: inline-block;
        margin-left: 20px;
      }
    }
    .content {
      margin-bottom: 36px;
      font-size: 16px;
      line-height: 1.8;
      word-wrap: break-word;
      p{
        font-size: 16px;
        line-height: 1.8;
      }
    }
  }

  .article-tip {
    // position: absolute;
    // bottom: 0;
    height: 65px;
    display: flex;
    align-items: center;
    color: var(--text-3, #8f949d);
    font-family: 'PingFang SC';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    border-top: 1px dashed #e0e5eb;
    width: 1240px;
  }
}
@media (max-width: 980px) {
  .home-content {
    width: 100%;
    height: calc(100vh - 100px);
    background: #fff;
    font-family: 'PingFang SC';
  }

  .card {
    min-height: 100%;
    margin: 100px auto 110px;
    background: #fff;
    border-radius: 12px;
    padding: 48px 30px;
    position: relative;
    h5 {
      color: var(---Text-1, #252629);
      font-family: 'PingFang SC';
      font-size: 40px;
      font-style: normal;
      font-weight: 500;
      line-height: 135%; /* 54px */
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    p {
      color: var(--text-3, #8f949d);
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 24px */
      margin-bottom: 32px;
      margin-top: 24px;
      span {
        display: inline-block;
        margin-right: 20px;
      }
    }
    .content {
      margin-bottom: 32px;
      word-wrap: break-word;
    }
  }

  .article-tip {
    display: flex;
    align-items: center;
    color: var(--text-3, #8f949d);
    font-family: 'PingFang SC';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    border-top: 1px dashed #e0e5eb;
    padding-top: 32px;
  }
}
</style>
